import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/impersonate')({
  beforeLoad: () => {
    throw redirect({ to: '/users' });
  },
});
